<div class="p-6 bg-white rounded-xl mb-20 gap-10">
  <h2 class="pb-[2.5rem]">{{ 'profile.hrContact.title' | transloco }}</h2>
  @if (loading()) {
  <div class="my-20"><loader /></div>
  } @else if (hrList().length > 0) {

  <div class="flex flex-col gap-10">
    <p class="text-left w-[80%]">{{ 'profile.hrContact.text' | transloco }}</p>
    <div class="grid grid-cols-1 md:grid-cols-3 gap-[1.5rem]">
      @for (hrContact of hrList(); track $index) {
      <app-contact-card
        [spId]="hrContact.spId!"
        [name]="hrContact.firstName + ' ' + hrContact.lastName"
        [job]="hrContact.job"
        [entity]="getHrContactEntity(hrContact)"
        [photoUrl]="hrContact.photoUrl"
        [mail]="hrContact.mail"
        [bookingLink]="getHrContactBookingLink(hrContact)"
        [allowSaving]="false"
      ></app-contact-card
      >}
    </div>
  </div>

  } @else {
  <p class="my-20 text-center">
    {{ 'profile.hrContact.noHrFound' | transloco }}
  </p>
  }
</div>
